export default "__VITE_PUBLIC_ASSET__48d44e9e__"